/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryListAliases {
  FRAGMENT_REFERENCE_ALLERGY = 'fragment-reference-allergy',
  FRAGMENT_REFERENCE_DISEASES = 'fragment-reference-diseases',
  FRAGMENT_REFERENCE_MEDICINES = 'fragment-reference-medicines',
  FRAGMENT_REFERENCE_SOCIAL_HISTORY = 'fragment-reference-social-history',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_HEALTH_HISTORY = 'layout-health-history',
  PANEL_TAB_CONTROL = 'panel-tab-control',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_ALLERGY = 'tab-with-content-allergy',
  TAB_WITH_CONTENT_DISEASES = 'tab-with-content-diseases',
  TAB_WITH_CONTENT_MEDICINES = 'tab-with-content-medicines',
  TAB_WITH_CONTENT_SOCIAL_HISTORY = 'tab-with-content-social-history',
}
export { HealthHistoryListAliases };
